import { DataSourceTable } from 'src/constants/dataSourceTable';
import { DEFAULT_SQL_QUOTE_CHARACTER } from 'src/constants/dataSourceTypeDescription';
import {
  SqlQuotingConvention,
  VirtualGraphOption,
} from 'src/store/state/dataSources';
import { ProjectVirtualGraphOptions } from 'src/store/state/projects';

export const closingQuoteCharacters: Record<string, string> = {
  '[': ']',
  '{': '}',
  '(': ')',
  '<': '>',
};

export const getSqlQuotingCharacters = ({
  nativeQuoteCharacter,
  options,
}: {
  nativeQuoteCharacter: string | null;
  options: ProjectVirtualGraphOptions;
}) => {
  const openQuote =
    options[VirtualGraphOption.SQL_QUOTING_CONVENTION] ===
    SqlQuotingConvention.ANSI
      ? DEFAULT_SQL_QUOTE_CHARACTER
      : nativeQuoteCharacter || DEFAULT_SQL_QUOTE_CHARACTER;
  const closeQuote = closingQuoteCharacters[openQuote] || openQuote;
  return { openQuote, closeQuote };
};

export const generateQualifiedTableName = ({
  nativeQuoteCharacter,
  options,
  table,
}: {
  nativeQuoteCharacter: string | null;
  options: ProjectVirtualGraphOptions;
  table: DataSourceTable;
}) => {
  const { openQuote, closeQuote } = getSqlQuotingCharacters({
    nativeQuoteCharacter,
    options,
  });
  return `${openQuote}${[table.catalog, table.schema, table.name]
    .filter(Boolean)
    .join(`${closeQuote}.${openQuote}`)}${closeQuote}`;
};
